import ContentTasksModal from './ContentTasksModal';

export default ContentTasksModal;
